<template>
  <div>
    <div v-if="!horizontal">
      <RecommendedCarousel/>
    </div>
  </div>
</template>
<script>

import UserCard from '@/components/users/UserCard'
import Slider from '@/components/widgets/Slider'
import RecommendedCarousel from "@/components/widgets/recommended/RecommendedCarousel.vue";
import {useRecommendedStore} from "@/store/recommended";

export default {
  name: 'InfluencerRecommendations',
  components: {RecommendedCarousel, UserCard, Slider},
  props: {
    empty: Boolean,
    horizontal: {type: Boolean, default: false}
  },
  setup() {
    const recommendedStore = useRecommendedStore()
    recommendedStore.list()
  }
}
</script>
<style lang="scss" scoped>
.user-row {
  padding: 2px;
  border-radius: 5px;
}

.discovery-card {
  width: 400px;
  text-align: center;
  margin: 16px auto;
}

.dark {
  background-color: rgba(0, 0, 0, 0.51) !important;

  .dark-title {
    color: #df3856 !important;
  }

  .dark-content {
    background-color: black !important;
    color: #df3856 !important;
  }
}
</style>
